import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { CyclistService } from '../../../../services/cyclist.service';
import { BikeService } from '../../../../services/bike.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { InvoiceService } from '../../../../services/invoice.service';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { JobcardService } from '../../../../services/jobcard.service';
import { CouponsService } from '../../../../services/coupons.service';
import { MenuItem } from 'primeng/api';
import { AppConfig } from '../../../../app.config';
import { Statuses } from '../../../../enums/statuses.enum';
import { CancellationReasons } from '../../../../enums/cancellation-reasons.enum';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Inplace } from 'primeng/inplace';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MultiSelect } from 'primeng/multiselect';
import { ThirdPartyService } from '../../../../services/thirdparty.service';
import { Project529ModalComponent } from '../../project529-modal/project529-modal.component';
import { UserService } from '../../../../services/user.service';
import { WorkshopJobcardCreateService } from '../../workshop-jobcard/workshop-jobcard-create.service';

@Component({
  selector: 'app-jobcard',
  templateUrl: './jobcard.component.html',
  styleUrls: ['./jobcard.component.scss'],
})
export class JobcardComponent implements OnInit {
  @Input() jobcard;
  @Input() bike;
  @Input() partnerID;
  @Input() cyclist;
  @Input() messageService;
  @Input() modal;
  @Input() initialLoad: boolean = true;
  @Output() update = new EventEmitter();
  @Output() completeChecklist = new EventEmitter();
  @Output() relinkJobCard = new EventEmitter();
  @Output() updateProject529Status = new EventEmitter();

  public busySaving: boolean = false;
  public jobActions: any = [];
  public serviceTypes: any = [];
  public selectedServiceTypes: any = [];
  //public selectedServiceTypeLinkedToThirdParty: boolean = false;
  //public selectedServiceTypeThirdPartyName: string;
  public jobStatus: number = 0;
  public technicianNote: string = '';
  public assessmentNote: string = '';
  public internalNote: string = '';
  public cancellationreasons: any = [];
  public jobCancelled: boolean = false;
  public selectedCancellationReason: any = [];
  public checkDisabled: any = Statuses.CANCELED && Statuses.COLLECTED;
  public currencySymbol = '';
  public initialAssesmentNote = '';
  public showUndo: boolean = false;
  public undoCompletion: boolean = false;
  public originalStatus: number = 0;
  public countDownValue: number = 0;
  public technicians: any = [];
  public bikes: any = [];
  public canMoveJobCard: boolean = false;
  public canCompleteJobCard: boolean = true;
  public CompleteJobCardTasks: any = [];
  public otherShops: any = [];
  public showMoveJobcardDialog: boolean = false;
  public TransferredFrom: String = null;
  public editInternalNote: boolean = false;
  public editAssessmentNote: boolean = false;
  public editClientNotes: boolean = false;
  public partnerData: any = {};
  public countryData: any = {};
  public displayDateFormat: any = 'dd-MM-yyyy';
  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';
  public sendComms: boolean = true;
  public submittingComplaint: boolean = false;
  public showCancellationOtherReason: boolean = false;
  public cancellationOtherReason: string = '';
  public setCalendarTimeFormat: number = 24;

  public showThirdParties: boolean = false;
  public thirdParties: any = [];
  public selectedThirdParty: any = null;
  public selectedThirdPartyIsResponsibileForPayment: boolean = false;

  public internalNotesRows = 1;
  public externalNotesRows = 1;
  public systemUsers: any = [];

  @ViewChild('serviceTypeDropDown') serviceTypeDropDown: MultiSelect;

  constructor(
    public cyclistService: CyclistService,
    public userService: UserService,
    public bikeService: BikeService,
    public serviceRequest: ServiceRequestService,
    public partnerService: PartnerService,
    public invoiceService: InvoiceService,
    public appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService,
    public confirmationService: ConfirmationService,
    public jobcardService: JobcardService,
    public couponsService: CouponsService,
    public thirdPartyService: ThirdPartyService,
    private modalService: NgbModal,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
  ) {
    this.currencySymbol = this.helpersService.getPartnerData().CurrencySymbol;
  }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();
    this.setCalendarTimeFormat = this.countryData.code == 'US' ? 12 : 24;
    this.displayDateFormat = this.countryData.AngularDateFormat;
    this.displayDateTimeFormat =
      this.countryData.AngularDateFormat +
      ' ' +
      (this.countryData.code == 'US' ? 'hh:mm aa' : 'HH:mm');

    this.setDate();
    this.initialAssesmentNote = this.jobcard.InitialAssesment_Notes;
    this.jobStatus = this.jobcard.StatusID;

    this.selectedThirdParty = this.jobcard.ThirdPartyID;
    this.selectedThirdPartyIsResponsibileForPayment =
      this.jobcard.ThirdPartyIsResponsibleForPayment;

    if (this.jobcard.IsFitting) {
      this.jobActions = [
        {
          key: Statuses.FITTINGCOMPLETED,
          label: this.translate.instant('bikeshop.job_actions.job_completed'),
          id: 41,
        },
        {
          key: Statuses.CANCELED,
          label: this.translate.instant('bikeshop.job_actions.cancel_job'),
          id: 100,
        },
      ];
    } else {
      this.jobActions = this.appConfig.getJobActions();
      if (!this.partnerData.ShowINeedHelp) {
        this.jobActions = this.jobActions.filter((x) => {
          return x.key != Statuses.INEEDHELP;
        });
      }
    }

    this.cancellationreasons = this.appConfig.getCancellationReasons();
    this.selectedCancellationReason = this.cancellationreasons[0];

    this.getService();
    this.getServiceTypes();
    this.getThirdParties();

    this.getTechnicians();
    this.getBikes();
    this.checkCanMove();
    this.getJobcardTransferInfo();
    this.checkCanComplete();
    this.getSystemUsers();

    this.selectedServiceTypes = this.jobcard.Types.map((type) => {
      return type.TypeID;
    });
  }

  getService() {
    if (!this.initialLoad) {
      this.serviceRequest
        .getServiceRequestData(this.jobcard.ID)
        .subscribe((jobcard) => {
          var originalDate = this.jobcard.OriginalBookInDate;
          this.jobcard = jobcard;
          this.jobcard.OriginalBookInDate = originalDate;
          this.setDate();
          this.update.emit(jobcard);
        });
    }
  }

  setDate() {
    try {
      if (
        this.jobcard &&
        this.jobcard.DateCheckedIn &&
        this.jobcard.DateCheckedIn.toString().indexOf('Z') ===
        this.jobcard.DateCheckedIn.toString().length - 1
      ) {
        this.jobcard.DateCheckedIn = this.jobcard.DateCheckedIn.substring(
          0,
          this.jobcard.DateCheckedIn.length - 1,
        );
      }
      this.jobcard.DateCheckedIn = moment(this.jobcard.DateCheckedIn).toDate();

      if (this.jobcard && this.jobcard.DateRequiredBy) {
        if (
          this.jobcard.DateRequiredBy.toString().indexOf('Z') ===
          this.jobcard.DateRequiredBy.toString().length - 1
        ) {
          this.jobcard.DateRequiredBy = this.jobcard.DateRequiredBy.substring(
            0,
            this.jobcard.DateRequiredBy.length - 1,
          );
        }
        this.jobcard.DateRequiredBy = moment(
          this.jobcard.DateRequiredBy,
        ).toDate();
      }
      if (
        this.cyclist &&
        this.cyclist.DateOfBirth &&
        this.cyclist.DateOfBirth.toString().indexOf('Z') ===
        this.cyclist.DateOfBirth.toString().length - 1
      ) {
        this.cyclist.DateOfBirth = this.cyclist.DateOfBirth.substring(
          0,
          this.cyclist.DateOfBirth.length - 1,
        );
      }
      this.cyclist.DateOfBirth =
        this.cyclist.DateOfBirth && this.cyclist.DateOfBirth.length > 0
          ? moment(this.cyclist.DateOfBirth).format('YYYY-MM-DD')
          : null;
    } catch (err) {
      console.log(err);
    }
  }

  checkCanMove() {
    this.jobcardService
      .canJobCardMove(this.partnerID, this.jobcard.ID)
      .subscribe(
        (result) => {
          if (result && result.length > 0) {
            this.canMoveJobCard = true;
            this.otherShops = result;
          }
        },
        (err) => { },
      );
  }

  checkCanComplete() {
    this.jobcardService
      .canJobCardBeCompleted(this.partnerID, this.jobcard.ID)
      .subscribe(
        (result) => {
          if (result && result.length == 0) {
            this.canCompleteJobCard = true;
          } else {
            for (var i = 0; i < result.length; i++) {
              this.CompleteJobCardTasks.push(result[i]);
            }
            this.canCompleteJobCard = false;
          }
        },
        (err) => { },
      );
  }

  alertToDos() {
    document.getElementById('cannotComplete').classList.add('shakes');
  }

  stopAlertToDos() {
    document.getElementById('cannotComplete').classList.remove('shakes');
  }

  getJobcardTransferInfo() {
    this.jobcardService.getJobcardTransferInfo(this.jobcard.ID).subscribe(
      (result) => {
        if (
          result &&
          result.transferredFrom &&
          result.transferredFrom.length > 0
        ) {
          this.TransferredFrom = result.transferredFrom;
        } else {
          this.TransferredFrom = null;
        }
      },
      (err) => {
        this.TransferredFrom = null;
      },
    );
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechnicians(this.partnerID)
      .subscribe((result) => {
        this.technicians = result
          .filter((technician) => {
            return technician.IsActive;
          })
          .map((x) => {
            return { value: x.ID, label: x.Firstname + ' ' + x.Surname };
          });
      });
  }

  getBikes() {
    this.cyclistService
      .getActiveBikesForCyclistAndPartner(this.cyclist.ID, this.partnerData.ID)
      .subscribe((result) => {
        this.bikes = result.map((x) => {
          return {
            value: x.ID,
            label: x.Manufacturer + ' ' + x.Model,
            serialNo: x.SerialNo,
          };
        });
      });
  }

  getServiceTypes() {
    this.serviceTypes = [];
    this.partnerService
      .getJobCardServiceTypesDropDowns(this.partnerID, this.jobcard.ID)
      .subscribe((serviceTypes) => {
        var GroupName = '';
        serviceTypes
          //.filter((serviceType) => {
          //  return serviceType.IsActive;
          //})
          .sort((x, y) => {
            return x.GroupOrder - y.GroupOrder || x.GroupName - y.GroupName;
          })
          .map((serviceType) => {
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant('general.not_grouped');
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              this.serviceTypes.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
                search: '',
                reverseSearch: '',
              });
            }
            var words = serviceType.ServiceTypeDescription.split(' ');
            var reverseSearch = [];
            if (words) {
              words.forEach((word) => {
                reverseSearch.unshift(word);
              });
            }
            this.serviceTypes.push({
              label:
                serviceType.ServiceTypeDescription +
                ' - ' +
                this.helpersService.getPartnerData().CurrencySymbol +
                serviceType.Cost,
              value: serviceType.ID,
              disabled: false,
              hours: serviceType.Hours,
              cost: serviceType.Cost,
              search: serviceType.ServiceTypeDescription,
              reverseSearch: reverseSearch.join(' '),
            });
          });

        //this.performThirdPartyFromServiceTypeSelected();
      });
  }

  getThirdParties() {
    this.thirdPartyService
      .getThirdParties(this.partnerID)
      .subscribe((result) => {
        this.thirdParties = result.map((item) => {
          return {
            label: item.name,
            value: item.id,
            disabled: false,
          };
        });

        if (this.thirdParties.length > 0) {
          this.showThirdParties = true;
        } else {
          this.showThirdParties = false;
        }

        this.thirdParties.splice(0, 0, {
          label: 'None',
          value: null,
          disabled: false,
        });

        //this.selectedThirdParty = null;
      });
  }

  addAssessmentNote() {
    this.assessmentNote = this.assessmentNote.replace(/(\r\n|\n|\r)/g, '<br/>');
    var note = this.assessmentNote;
    this.assessmentNote = '';
    if (!this.busySaving && note && note.length > 0) {
      this.busySaving = true;
      this.serviceRequest
        .saveAssessmentNote(this.jobcard.ID, note, this.countryData)
        .subscribe(
          (jobcard) => {
            this.busySaving = false;
            //var originalDate = this.jobcard.OriginalBookInDate;
            //this.jobcard = jobcard;
            this.jobcard.InitialAssesment_Notes =
              jobcard.InitialAssesment_Notes;
            //this.jobcard.OriginalBookInDate = originalDate;
            //this.setDate();
            //this.update.emit(jobcard);
            this.assessmentNote = '';
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_assessment_note_saved',
                { JobCardNo: this.jobcard.JobCardNo },
              ),
            });
          },
          (err) => {
            this.busySaving = false;
          },
        );
    }
  }

  updateAssessmentNote() {
    this.jobcard.InitialAssesment_Notes =
      this.jobcard.InitialAssesment_Notes.replace(/(\r\n|\n|\r)/g, '<br/>');
    this.editAssessmentNote = false;
    this.serviceRequest
      .updateAssessmentNote(
        this.jobcard.ID,
        this.jobcard.InitialAssesment_Notes,
      )
      .subscribe((jobcard) => {
        //    var originalDate = this.jobcard.OriginalBookInDate;
        // this.jobcard = jobcard;
        // InitialAssesment_Note
        this.jobcard.InitialAssesment_Notes = jobcard.InitialAssesment_Notes;
        //   this.jobcard.OriginalBookInDate = originalDate;
        // this.setDate();
        // this.update.emit(jobcard);
        this.assessmentNote = '';
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_assessment_note_saved',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
      });
  }

  addInternalNote() {
    this.internalNote = this.internalNote.replace(/(\r\n|\n|\r)/g, '<br/>');
    var note = this.internalNote;
    this.internalNote = '';
    if (!this.busySaving && note && note.length > 0) {
      this.busySaving = true;
      this.serviceRequest
        .saveInternalNote(this.jobcard.ID, note, this.countryData)
        .subscribe(
          (jobcard) => {
            this.busySaving = false;
            //var originalDate = this.jobcard.OriginalBookInDate;
            // this.jobcard = jobcard;
            this.jobcard.PostServiceInspection_Notes =
              jobcard.PostServiceInspection_Notes;
            //this.jobcard.OriginalBookInDate = originalDate;
            // this.getService();
            //  this.setDate();

            //  this.update.emit(jobcard);
            this.internalNote = '';
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_internal_note_saved',
                { JobCardNo: this.jobcard.JobCardNo },
              ),
            });
          },
          (err) => {
            this.busySaving = false;
          },
        );
    }
  }

  startEditInternalNote() {
    this.jobcard.PostServiceInspection_Notes =
      this.jobcard.PostServiceInspection_Notes.replaceAll('<br/>', '\r\n');
    this.jobcard.PostServiceInspection_Notes =
      this.jobcard.PostServiceInspection_Notes.replaceAll('<br>', '\r\n');
    this.editInternalNote = true;
  }

  startEditClientNote() {
    this.jobcard.Client_Notes = this.jobcard.Client_Notes.replaceAll(
      '<br/>',
      '\r\n',
    );
    this.jobcard.Client_Notes = this.jobcard.Client_Notes.replaceAll(
      '<br>',
      '\r\n',
    );
    this.editClientNotes = true;
  }

  startEditAssessmentNote() {
    this.jobcard.InitialAssesment_Notes =
      this.jobcard.InitialAssesment_Notes.replaceAll('<br/>', '\r\n');
    this.jobcard.InitialAssesment_Notes =
      this.jobcard.InitialAssesment_Notes.replaceAll('<br>', '\r\n');
    this.editAssessmentNote = true;
  }

  updateInternalNote() {
    this.jobcard.PostServiceInspection_Notes =
      this.jobcard.PostServiceInspection_Notes.replace(
        /(\r\n|\n|\r)/g,
        '<br/>',
      );
    this.editInternalNote = false;
    this.serviceRequest
      .updateInternalNote(
        this.jobcard.ID,
        this.jobcard.PostServiceInspection_Notes,
      )
      .subscribe((jobcard) => {
        var originalDate = this.jobcard.OriginalBookInDate;
        // this.jobcard = jobcard;
        this.jobcard.PostServiceInspection_Notes =
          jobcard.PostServiceInspection_Notes;
        // this.jobcard.OriginalBookInDate = originalDate;
        // this.setDate();
        // this.update.emit(jobcard);
        // this.internalNote = '';
        // this.changeDetector.detectChanges();

        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_internal_note_saved',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
      });
  }

  updateClientNote() {
    this.jobcard.Client_Notes = this.jobcard.Client_Notes.replace(
      /(\r\n|\n|\r)/g,
      '<br/>',
    );
    this.editClientNotes = false;
    this.serviceRequest
      .updateClientNote(this.jobcard.ID, this.jobcard.Client_Notes)
      .subscribe((jobcard) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_client_note_saved',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
      });
  }

  updateJobcard() { }

  updateCyclist(event, type) {
    if (
      !this.busySaving &&
      (type === 'PhoneNumber' ||
        type === 'Name' ||
        type === 'Surname' ||
        type === 'DateOfBirth' ||
        (type === 'Email' && this.validateEmail()))
    ) {
      this.busySaving = true;
      this.cyclistService.getCyclistById(this.cyclist.ID).subscribe(
        (result) => {
          var cyclist = { ...result };
          cyclist.PartnerID = this.partnerID;
          //if (type === 'PhoneNumber') {
          cyclist.PhoneNumber = this.cyclist.PhoneNumber;
          //}
          //if (type === 'Name') {
          cyclist.Name = this.cyclist.Name;
          //}
          //if (type === 'Surname') {
          cyclist.Surname = this.cyclist.Surname;
          //}
          //if (type === 'Email') {
          cyclist.Email = this.cyclist.Email;
          //}
          //if (type === 'DateOfBirth') {
          cyclist.DateOfBirth = new Date(
            moment(this.cyclist.DateOfBirth).format('YYYY-MM-DDTHH:mm') + 'Z',
          );
          //}
          console.log(cyclist);
          this.userService.updateCustomer(cyclist).subscribe(
            (updatedCyclist) => {
              if (
                updatedCyclist.Data.DateOfBirth &&
                updatedCyclist.Data.DateOfBirth.toString().indexOf('Z') ===
                updatedCyclist.Data.DateOfBirth.toString().length - 1
              ) {
                updatedCyclist.Data.DateOfBirth =
                  updatedCyclist.Data.DateOfBirth.substring(
                    0,
                    updatedCyclist.Data.DateOfBirth.length - 1,
                  );
              }
              updatedCyclist.Data.DateOfBirth =
                updatedCyclist.Data.DateOfBirth &&
                  updatedCyclist.Data.DateOfBirth.length > 0
                  ? moment(updatedCyclist.DateOfBirth).format('YYYY-MM-DD')
                  : null;

              this.cyclist = updatedCyclist.Data;
              if (event !== null) {
                event.deactivate();
              }
              this.busySaving = false;
              this.messageService.add({
                life: 5000,
                detail: this.translate.instant(
                  'bikeshop.modal.update_job_card.job_card.cyclist_information_updated',
                ),
              });
            },
            (error) => {
              this.busySaving = false;
              if (error.statusText === 'Conflict') {
                this.confirmationService.confirm({
                  key: 'jobcard',
                  header: this.translate.instant(
                    'messages.error_updating_jobcard_user_title',
                  ),
                  message: this.translate.instant(
                    'messages.error_updating_jobcard_user',
                  ),
                  acceptLabel: this.translate.instant('general.yes'),
                  accept: () => {
                    this.relinkJobCard.emit(this.cyclist);
                  },
                  rejectLabel: this.translate.instant('general.no'),
                });
              } else if (error.error && error.error.error && error.error.error === "CUSTOMER_EXISTS") {
                this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.customer.error.customer_exists') });
              } else {
                this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.customer.error.customer_general_error') });
              }
            },
          );
        },
        (error) => { },
      );
    }
  }

  validateEmail() {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.cyclist.Email).toLowerCase());
  }

  updateTechnicianNote() {
    this.technicianNote = this.technicianNote.replace(/(\r\n|\n|\r)/g, '<br/>');
    if (this.technicianNote && this.technicianNote.length > 0) {
      this.serviceRequest
        .saveTechnicianNote(
          this.jobcard.ID,
          this.technicianNote,
          this.countryData,
        )
        .subscribe((jobcard) => {
          var originalDate = this.jobcard.OriginalBookInDate;
          this.jobcard = jobcard;
          this.jobcard.OriginalBookInDate = originalDate;
          this.setDate();
          this.update.emit(jobcard);
          this.technicianNote = '';
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.modal.update_job_card.job_card.message_technician_note_added',
              { JobCardNo: jobcard.JobCardNo },
            ),
          });
        });
    }
  }

  // performThirdPartyFromServiceTypeSelected(){
  //   // Check if any selected item has hasPartnerServiceType set to true
  //   if(this.selectedServiceTypes.length)
  //   {
  //     //Has items selected
  //     this.selectedServiceTypeLinkedToThirdParty = this.selectedServiceTypes.some(selectedValue => {
  //       //Get item selected details
  //       const selectedItem = this.serviceTypes.find(item => item.value === selectedValue);

  //       //Check if item selected is linked to third party
  //       if(selectedItem && selectedItem.hasPartnerServiceType === true)
  //       {
  //         //Only enable third parties of same type
  //         this.selectedServiceTypeThirdPartyName = selectedItem.thirdPartyName;
  //         this.serviceTypes.forEach(item => {
  //           if (item.thirdPartyName !== selectedItem.thirdPartyName) {
  //             item.disabled = true;
  //           }
  //           else if(item.value == -1)
  //           {
  //             item.disabled = true;
  //           }
  //           else{
  //             item.disabled = false;
  //           }
  //         });
  //         return true;
  //       }
  //       else{
  //         //Item selected is not linked to third party
  //         this.selectedServiceTypeThirdPartyName = "";
  //         this.serviceTypes.forEach(item => {
  //           if(item.value == -1 || item.thirdPartyName.length > 0)
  //           {
  //             item.disabled = true;
  //           }
  //           else{
  //             item.disabled = false;
  //           }
  //         });
  //         return false;
  //       }
  //     });
  //   }
  //   else{
  //     //No items selected
  //     this.selectedServiceTypeThirdPartyName = "";
  //     this.selectedServiceTypeLinkedToThirdParty = false;
  //     this.serviceTypes.forEach(item => {
  //       if(item.value == -1)
  //       {
  //         item.disabled = true;
  //       }
  //       else{
  //         item.disabled = false;
  //       }
  //     });
  //   }
  // }

  updateServiceTypes() {
    //this.performThirdPartyFromServiceTypeSelected();

    var currentServiceTypes = this.jobcard.Types.map((type) => {
      return type.TypeID;
    });

    if (this.selectedServiceTypes !== currentServiceTypes) {
      var serviceTypeIDS = this.serviceTypes.map((service) => {
        return service.value;
      });

      var newDuration = 0;
      if (this.selectedServiceTypes.length) {
        newDuration = this.serviceTypes
          .filter((service) => {
            return this.selectedServiceTypes.indexOf(service.value) > -1;
          })
          .map((service) => {
            return service.hours;
          })
          .reduce((total, num) => {
            return total + num;
          });
      }

      var newCost = 0;
      if (this.selectedServiceTypes.length) {
        newCost = this.serviceTypes
          .filter((service) => {
            return this.selectedServiceTypes.indexOf(service.value) > -1;
          })
          .map((service) => {
            return service.cost;
          })
          .reduce((total, num) => {
            return total + num;
          });
      }

      var jobcardUpdate = JSON.parse(JSON.stringify(this.jobcard));
      jobcardUpdate.Duration = newDuration * 60;
      jobcardUpdate.Duration = parseInt(jobcardUpdate.Duration);
      jobcardUpdate.PriceEstimate = newCost;
      jobcardUpdate.Types = this.selectedServiceTypes.map((service) => {
        return {
          TypeID: service,
          TypeDescription:
            this.serviceTypes[serviceTypeIDS.indexOf(service)].label,
        };
      });

      jobcardUpdate.ThirdPartyID = this.selectedThirdParty;
      jobcardUpdate.ThirdPartyIsResponsibleForPayment =
        this.selectedThirdPartyIsResponsibileForPayment;

      this.serviceRequest
        .saveServiceRequest(jobcardUpdate)
        .subscribe((jobcard) => {
          this.jobcard.ThirdPartyID = jobcardUpdate.ThirdPartyID;
          this.jobcard.Types = jobcard.Types;
          this.jobcard.Duration = jobcard.Duration;
          this.update.emit(this.jobcard);
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.modal.update_job_card.job_card.message_service_types_updated',
              { JobCardNo: this.jobcard.JobCardNo },
            ),
          });
          //TODO The duration does not seem to update when we update service types, the estimated price changes but not the duration.
        });
    }
    this.serviceTypeDropDown.filterValue = '';
  }

  undoCompletionTask() {
    this.undoCompletion = true;
    this.jobStatus = this.originalStatus;
    this.busySaving = false;
    this.showUndo = false;
    this.messageService.add({
      life: 5000,
      detail: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.message_completion_undone',
      ),
    });
  }

  countDown(value) {
    this.countDownValue = value;
    if (value > 0) {
      setTimeout(() => {
        this.countDown(value - 1);
      }, 1000);
    }
  }

  updateStatus(status) {
    this.busySaving = true;
    this.originalStatus = this.jobStatus;
    this.jobStatus = status.id;
    switch (status.key) {
      case Statuses.BOOKEDIN:
        this.serviceRequest
          .bikeReceived(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.BikeIsHere = true;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.busySaving = false;
          });
        break;
      case Statuses.WAITINGFORWORK:
        this.serviceRequest
          .waitingForWork(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_jobcard_assigned',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.busySaving = false;
          });
        break;
      // case Statuses.ASSIGNED:
      //   this.serviceRequest
      //     .assignToTechnician(this.jobcard.ID, this.jobcard.TechnicianID)
      //     .subscribe((jobcard) => {
      //       this.messageService.add({
      //         life: 5000,
      //         detail: this.translate.instant(
      //           "bikeshop.modal.update_job_card.job_card.message_jobcard_assigned",
      //           { JobCardNo: jobcard.JobCardNo }
      //         ),
      //       });
      //       this.jobcard = jobcard;
      //       this.setDate();
      //       this.update.emit(this.jobcard);
      //       this.busySaving = false;
      //     });
      //   break;
      case Statuses.WORKINGON:
        this.serviceRequest
          .startWork(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.BikeIsHere = true;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_job_commenced',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            this.busySaving = false;
          });
        break;
      case Statuses.WARRANTY:
        this.serviceRequest
          .startWarrantyWork(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.BikeIsHere = true;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_warranty_job_commenced',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            this.busySaving = false;
          });
        break;
      case Statuses.COMPLETED:
        this.showUndo = true;
        this.countDown(5);
        setTimeout(() => {
          if (!this.undoCompletion) {
            this.showUndo = false;
            this.undoCompletion = false;
            // this.serviceRequest
            //   .completeWork(this.jobcard.ID)
            //   .subscribe((jobcard) => {
            //     var originalDate = this.jobcard.OriginalBookInDate;
            //     this.jobcard = jobcard;
            //     this.jobcard.OriginalBookInDate = originalDate;
            //     this.setDate();
            //     this.update.emit(this.jobcard);
            //     this.captureService(jobcard);
            //   });
            this.serviceRequest
              .readyForCollectionV2(this.jobcard.ID, this.sendComms)
              .subscribe(
                (jobcard) => {
                  this.busySaving = false;
                  this.messageService.add({
                    life: 5000,
                    detail: this.translate.instant(
                      'bikeshop.modal.update_job_card.job_card.message_job_completed',
                      { JobCardNo: jobcard.JobCardNo },
                    ),
                  });

                  this.jobcard.StatusID = jobcard.StatusID;
                  this.jobcard.BikeIsHere = true;
                  this.jobcard.StatusDescription = jobcard.StatusDescription;
                  this.update.emit(this.jobcard);
                },
                (err) => {
                  console.log(err);
                  this.messageService.add({
                    life: 5000,
                    detail: this.translate.instant(
                      'bikeshop.modal.update_job_card.job_card.message_job_completed_err',
                      { JobCardNo: this.jobcard.JobCardNo },
                    ),
                  });
                  this.busySaving = false;
                },
              );
          } else {
            this.undoCompletion = false;
          }
        }, 5000);

        break;
      /*case Statuses.COMPLETED:
                                                                          this.serviceRequest.jobCompleted(this.jobcard.ID).subscribe(jobcard => {
                                                                            this.jobcard = jobcard;
                                                                            this.update.emit(this.jobcard);
                                                                            this.messageService.add({
                                                                              life: 5000,
                                                                              detail: this.translate.instant(
                                                                                'bikeshop.modal.update_job_card.job_card.message_job_completed',
                                                                                { JobCardNo: jobcard.JobCardNo }
                                                                              )
                                                                            });
                                                                            this.busySaving = false;
                                                                          });
                                                                          break;*/
      case Statuses.INEEDHELP:
        this.serviceRequest.iNeedHelp(this.jobcard.ID).subscribe((jobcard) => {
          var originalDate = this.jobcard.OriginalBookInDate;
          this.jobcard = jobcard;
          this.jobcard.BikeIsHere = true;
          this.jobcard.OriginalBookInDate = originalDate;
          this.setDate();
          this.update.emit(this.jobcard);
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              this.helpersService.getPartnerData() &&
                this.helpersService.getPartnerData().INeedHelpLabel
                ? 'bikeshop.modal.update_job_card.job_card.message_job_paused_custom'
                : 'bikeshop.modal.update_job_card.job_card.message_job_paused_i_need_help',
              {
                JobCardNo: jobcard.JobCardNo,
                CustomLabel:
                  this.helpersService.getPartnerData().INeedHelpLabel,
              },
            ),
          });
          this.busySaving = false;
        });
        break;
      case Statuses.WAITINGPARTS:
        this.serviceRequest
          .waitingForParts(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_job_paused_waiting_parts',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            this.busySaving = false;
          });
        break;
      case Statuses.WAITINGCLIENT:
        this.serviceRequest
          .waitingForClient(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.BikeIsHere = true;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_job_paused_waiting_client',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
            this.busySaving = false;
          });
        break;
      case Statuses.FITTINGCOMPLETED:
        this.serviceRequest
          .jobCompleted(this.jobcard.ID, this.sendComms)
          .subscribe((jobcard) => {
            var originalDate = this.jobcard.OriginalBookInDate;
            this.jobcard = jobcard;
            this.jobcard.OriginalBookInDate = originalDate;
            this.setDate();
            this.update.emit(this.jobcard);
            //this.messageService.add({
            //  life: 5000,
            //  detail: this.translate.instant(
            //    "bikeshop.modal.update_job_card.job_card.message_job_paused_waiting_client",
            //    { JobCardNo: jobcard.JobCardNo }
            //  ),
            //});
            this.busySaving = false;
          });
        break;
      case Statuses.CANCELED:
        this.busySaving = false;
        this.selectedCancellationReason = {};
        this.jobCancelled = true;
        break;
      default:
        {
          this.jobcard.id = this.jobcard.ID;
          var result = this.workshopJobcardCreateService.updateJobCardStatus(this.jobcard, status.id, this.sendComms, this.messageService, this.translate).subscribe(x => {
            this.jobcard.StatusID = status.id;
            this.update.emit(this.jobcard);
            this.busySaving = false;
          });
          break;
        }
    }
  }

  changeServiceDate() {
    // var jobcard = JSON.parse(JSON.stringify(this.jobcard));
    // jobcard.DateCheckedIn = new Date(moment(this.jobcard.DateCheckedIn).format("YYYY-MM-DDTHH:mm") + 'Z');
    // this.serviceRequest
    //   .saveServiceRequest(jobcard)
    //   .subscribe((savedJobCard) => {
    //     this.messageService.add({
    //       life: 5000,
    //       summary: this.translate.instant("bikeshop.calendar.job_update"),
    //       detail: this.translate.instant(
    //         "bikeshop.calendar.message_job_updated",
    //         { JobCardNo: this.jobcard.JobCardNo }
    //       ),
    //     });
    //   });
    var data = {
      DateCheckedIn: new Date(
        moment(this.jobcard.DateCheckedIn).format('YYYY-MM-DDTHH:mm') + 'Z',
      ),
      ID: this.jobcard.ID,
      TechnicianID: this.jobcard.TechnicianID,
    };
    this.serviceRequest.updateJobCardSlot(data).subscribe((res) => {
      this.messageService.add({
        life: 5000,
        summary: this.translate.instant('bikeshop.calendar.job_update'),
        detail: this.translate.instant(
          'bikeshop.calendar.message_job_updated',
          { JobCardNo: this.jobcard.JobCardNo },
        ),
      });
    });
  }

  captureService(jobcard) {
    this.serviceRequest
      .getServiceRequestData(jobcard.ID)
      .subscribe((serviceData) => {
        this.bikeService.getBike(jobcard.BikeID).subscribe((bike) => {
          //1. Get Bikes Active Gear
          this.bikeService
            .getActiveGear(jobcard.BikeID)
            .subscribe((activeGear) => {
              //2. Get Gear Replacement List from POS
              this.serviceRequest
                .getGearReplacementFromPOS(jobcard.ID)
                .subscribe(
                  (gearReplacement) => {
                    //3. Get Invoice for Bike
                    this.invoiceService
                      .getInvoice(jobcard.ID, false)
                      .subscribe((invoice) => {
                        //4. Capture Service
                        let captureServiceData = {
                          BikeID: jobcard.BikeID,
                          PartnerID: this.partnerID,
                          ServiceRequestID: serviceData.ID,
                          ServiceDate: serviceData.DateCheckedIn,
                          ServicedGear: gearReplacement,
                        };

                        this.bikeService
                          .captureService(captureServiceData)
                          .subscribe((service) => {
                            //5. Make bike ready for collection
                            this.serviceRequest
                              .readyForCollection(
                                this.jobcard.ID,
                                this.sendComms,
                              )
                              .subscribe((jobcard) => {
                                this.busySaving = false;
                                this.messageService.add({
                                  life: 5000,
                                  detail: this.translate.instant(
                                    'bikeshop.modal.update_job_card.job_card.message_job_completed',
                                    { JobCardNo: jobcard.JobCardNo },
                                  ),
                                });

                                this.jobcard.StatusID = jobcard.StatusID;
                                this.jobcard.StatusDescription =
                                  jobcard.StatusDescription;
                                this.update.emit(this.jobcard);
                              });
                          });
                      });
                  },
                  (err) => {
                    this.invoiceService
                      .getInvoice(jobcard.ID, false)
                      .subscribe((invoice) => {
                        //4. Capture Service
                        let captureServiceData = {
                          BikeID: jobcard.BikeID,
                          PartnerID: this.partnerID,
                          ServiceRequestID: serviceData.ID,
                          ServiceDate: serviceData.DateCheckedIn,
                          ServicedGear: null,
                        };

                        this.bikeService
                          .captureService(captureServiceData)
                          .subscribe((service) => {
                            //5. Make bike ready for collection
                            this.serviceRequest
                              .readyForCollection(
                                this.jobcard.ID,
                                this.sendComms,
                              )
                              .subscribe((jobcard) => {
                                this.busySaving = false;
                                this.messageService.add({
                                  life: 5000,
                                  detail: this.translate.instant(
                                    'bikeshop.modal.update_job_card.job_card.message_job_completed',
                                    { JobCardNo: jobcard.JobCardNo },
                                  ),
                                });

                                this.jobcard.StatusID = jobcard.StatusID;
                                this.jobcard.StatusDescription =
                                  jobcard.StatusDescription;
                                this.update.emit(this.jobcard);
                              });
                          });
                      });
                  },
                );
            });
        });
      });
  }

  beginJobCancellation() {
    if (this.selectedCancellationReason == CancellationReasons.OTHER) {
      this.busySaving = false;
      this.cancellationOtherReason = '';
      this.showCancellationOtherReason = true;
    } else {
      this.cancelJob();
    }
  }

  isTesting() {
    return this.selectedCancellationReason == CancellationReasons.TESTING;
  }

  cancelJob() {
    this.busySaving = true;
    var reason_ids = this.cancellationreasons.map((reason) => {
      return reason.value;
    });
    var reason =
      this.cancellationreasons[
        reason_ids.indexOf(this.selectedCancellationReason)
      ].label;
    this.serviceRequest
      .cancelJob(
        this.jobcard.ID,
        reason,
        this.cancellationOtherReason,
        this.selectedCancellationReason == CancellationReasons.TESTING,
      )
      .subscribe((jobcard) => {
        this.jobCancelled = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_job_cancelled',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });

        if (this.partnerData.POSSystemID > 10) {
          this.invoiceService
            .getInvoiceV2(this.jobcard.ID, false)
            .subscribe((inv) => {
              this.invoiceService
                .manageInvoicePOSExtras(inv.ID)
                .subscribe((res) => {
                  this.busySaving = false;
                  this.showCancellationOtherReason = false;
                  this.jobcard.StatusID = 100;
                });
            });
        } else {
          this.busySaving = false;
          this.showCancellationOtherReason = false;
          this.jobcard.StatusID = 100;
        }
        //this.update.emit(jobcard);
      });
  }

  bikeCollected() {
    this.busySaving = true;
    this.serviceRequest
      .collect(this.jobcard.ID, this.sendComms)
      .subscribe((jobcard) => {
        var originalDate = this.jobcard.OriginalBookInDate;
        this.jobcard = jobcard;
        this.jobcard.BikeIsHere = false;
        this.jobcard.OriginalBookInDate = originalDate;
        this.setDate();
        this.update.emit(this.jobcard);
        this.busySaving = false;
      });
  }

  // printJobCard() {
  //   if (
  //     this.helpersService.getPrinterType() === null ||
  //     this.helpersService.getPrinterType() === "A4"
  //   ) {
  //     var win = window.open(`/print/${this.jobcard.ID}`, "_blank");
  //     win.focus();
  //   } else {
  //     var win = window.open(`/print-till-slip/${this.jobcard.ID}`, "_blank");
  //     win.focus();
  //   }
  // }

  updateTechnician() {
    this.serviceRequest
      .saveServiceRequest(this.jobcard)
      .subscribe((jobcard) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.technician_updated',
            { JobCardNo: jobcard.JobCardNo },
          ),
        });
      });
  }

  updateBike() {
    this.serviceRequest
      .saveServiceRequest(this.jobcard)
      .subscribe((jobcard) => {
        var bike = this.bikes
          .filter((x) => {
            return x.value == this.jobcard.BikeID;
          })
          .pop();
        if (bike) {
          this.jobcard.SerialNo = bike.serialNo;
          this.jobcard.project529 = {};
          this.updateProject529Status.emit();
        }
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.bike_updated',
            { JobCardNo: jobcard.JobCardNo },
          ),
        });
      });
  }

  showMoveDialog() {
    this.showMoveJobcardDialog = true;
  }

  closeMoveJobcardDialog() {
    this.showMoveJobcardDialog = false;
  }

  jobCardMoved(data) {
    this.canMoveJobCard = false;
    this.showMoveJobcardDialog = false;
    this.messageService.add({
      life: 5000,
      detail: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.moved',
        { shopName: data.shopName },
      ),
    });
    setTimeout(() => {
      this.modal.dismiss('Cross click');
    }, 5000);
  }

  isOriginalDate() {
    return (
      moment(this.jobcard.DateCheckedIn).format('YYYY-MM-DD') ===
      moment(this.jobcard.OriginalBookInDate).format('YYYY-MM-DD')
    );
  }

  isValidDate() {
    return (
      moment(this.jobcard.OriginalBookInDate).format('YYYY-MM-DD') !==
      '0001-01-01'
    );
  }

  isBikeHere() {
    return this.jobStatus > 15 && this.jobStatus < 50;
  }

  updateBikeBay(event) {
    if (!this.busySaving) {
      this.busySaving = true;
      event.deactivate();
      var jobcard = JSON.parse(JSON.stringify(this.jobcard));
      this.serviceRequest
        .saveServiceRequest(jobcard)
        .subscribe((savedJobCard) => {
          this.busySaving = false;
          this.messageService.add({
            life: 5000,
            summary: this.translate.instant('bikeshop.calendar.job_update'),
            detail: this.translate.instant(
              'bikeshop.calendar.message_job_updated',
              { JobCardNo: this.jobcard.JobCardNo },
            ),
          });
        });
    }
  }

  updateBikeIsHere(event) {
    this.jobcard.BikeIsHere = event.checked;
    this.serviceRequest.saveServiceRequest(this.jobcard).subscribe((result) => {
      if (!event.checked) {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_undo_bike_received',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
        if (this.jobcard.StatusID === 20) {
          this.serviceRequest
            .undoBikeReceived(this.jobcard.ID)
            .subscribe((res) => {
              this.jobStatus = res.StatusID;
              this.jobcard.StatusID = res.StatusID;
            });
        }
      } else {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
        if (this.jobcard.StatusID < 20) {
          this.serviceRequest
            .bikeReceived(this.jobcard.ID, this.sendComms)
            .subscribe((res) => {
              this.jobStatus = res.StatusID;
              this.jobcard.StatusID = res.StatusID;
            });
        }
      }
    });

    /*if (!event.checked) {
                                                  this.busySaving = true;
                                                  this.serviceRequest.undoBikeReceived(this.jobcard.ID).subscribe(res => {
                                                    this.jobStatus = res.StatusID;
                                                    this.jobcard.StatusID = res.StatusID;
                                                    this.busySaving = false;
                                                    this.messageService.add({
                                                      life: 5000,
                                                      detail: this.translate.instant(
                                                        "bikeshop.modal.update_job_card.job_card.message_undo_bike_received",
                                                        { JobCardNo: this.jobcard.JobCardNo }
                                                      ),
                                                    });
                                                  }, err => {
                                                    this.busySaving = false;
                                                  });
                                                } else {
                                                  this.busySaving = true;
                                                  this.serviceRequest.bikeReceived(this.jobcard.ID).subscribe(res => {
                                                    this.jobStatus = res.StatusID;
                                                    this.jobcard.StatusID = res.StatusID;
                                                    this.busySaving = false;
                                                    this.messageService.add({
                                                      life: 5000,
                                                      detail: this.translate.instant(
                                                        "bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned",
                                                        { JobCardNo: this.jobcard.JobCardNo }
                                                      ),
                                                    });
                                                  }, err => {
                                                    this.busySaving = false;
                                                  });
                                                }*/
  }

  reopenJobCard() {
    this.confirmationService.confirm({
      key: 'jobcard',
      header: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.reopen_job_card',
      ),
      message: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.reopen_job_card_detail',
      ),
      acceptLabel: this.translate.instant('general.yes'),
      accept: () => {
        this.busySaving = true;
        this.serviceRequest.reopenJobcard(this.jobcard.ID).subscribe(
          (res) => {
            this.jobStatus = res.StatusID;
            this.jobcard.StatusID = res.StatusID;
            this.busySaving = false;
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_job_card_reopened',
                { JobCardNo: this.jobcard.JobCardNo },
              ),
            });
          },
          (err) => {
            this.busySaving = false;
          },
        );
      },
      rejectLabel: this.translate.instant('general.no'),
    });
  }

  changeRequiredDate() {
    var jobcard = JSON.parse(JSON.stringify(this.jobcard));
    jobcard.DateCheckedIn = new Date(
      moment(this.jobcard.DateCheckedIn).format('YYYY-MM-DDTHH:mm') + 'Z',
    );
    jobcard.DateRequiredBy = new Date(
      moment(this.jobcard.DateRequiredBy).format('YYYY-MM-DDTHH:mm') + 'Z',
    );
    this.serviceRequest
      .saveServiceRequest(jobcard)
      .subscribe((savedJobCard) => {
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant('bikeshop.calendar.job_update'),
          detail: this.translate.instant(
            'bikeshop.calendar.message_job_updated',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
      });
  }

  setInternalNotesRows() {
    this.internalNotesRows = 5;
  }

  resetInternalNotesRows() {
    this.internalNotesRows = 1;
  }

  setExternalNotesRows() {
    this.externalNotesRows = 5;
  }

  resetExternalNotesRows() {
    this.externalNotesRows = 1;
  }

  preventDefaultTab(event) {
    event.preventDefault();
  }

  compaintReceived() {
    this.submittingComplaint = true;
    this.serviceRequest.submitServiceComplaint(this.jobcard.ID).subscribe(
      (res) => {
        this.submittingComplaint = false;
        this.jobcard.ComplaintFlagged = true;
        this.update.emit(this.jobcard);
      },
      (err) => {
        this.submittingComplaint = false;
      },
    );
  }

  getSystemUsers() {
    this.partnerService
      .getPartnerSystemUsers(this.partnerID)
      .subscribe((users) => {
        this.systemUsers = users.map((x) => {
          return {
            value: x.ID,
            label: x.Name ? x.Name + ' ' + x.Surname : x.Email,
          };
        });
      });
  }

  updateBookedInBy() {
    var jobcard = JSON.parse(JSON.stringify(this.jobcard));

    this.serviceRequest
      .saveServiceRequest(jobcard)
      .subscribe((savedJobCard) => {
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant('bikeshop.calendar.job_update'),
          detail: this.translate.instant(
            'bikeshop.calendar.message_job_updated',
            { JobCardNo: this.jobcard.JobCardNo },
          ),
        });
      });
  }

  project529Action(status) {
    if (status.status != 'Registered') {
      const modalRef = this.modalService.open(Project529ModalComponent, {
        //backdrop: 'static',
        backdropClass: 'project529-modal-background',
        windowClass: 'project529-modal-window',
      });
      modalRef.componentInstance.jobcard = this.jobcard;
      modalRef.componentInstance.bike = this.bike;
      modalRef.componentInstance.messageService = this.messageService;
    }
  }
}
